import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idLeadCorretor: string | undefined;
  tipoLogLead: number | undefined;
}

interface LogsLeadInterface {
  nome: string;
  codigoTipoLogLead: string;
  idLead: string | undefined;
  idLeadCorretor: string | undefined;
  idCorretorRealizacaoAcao: string;
  idTipoLogLead: string;
  nomeCorretor: string;
  nomeFotoCorretor: string;
  dataAtualizacao: string;
  nomeTipoTarefa: string;
  observacao: string;
  tipoResultadoTarefa: string;
  nomeStatusTarefa: string;
  dataHoraProgramadaRealizacaoTarefa: string;
  nomeMotivoDesqualificacaoLead: string;
  nomeCorretorOrigem: string;
  nomeCorretorDestino: string;
  nomeCorretorAtendimento: string;
  valores: Array<{
    campoAlterado: string;
    valorAntigo: string;
    valorNovo: string;
  }>;
}

export function useLogsLead(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const LOGS_LEAD = `${leadsWebEnviroment}/app-web/logs-lead/${props.idLeadCorretor}?tipoLogLead=${props.tipoLogLead}`;
    const response = await instance.get(LOGS_LEAD);
    return response?.data?.data as LogsLeadInterface[];
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey, props.idLeadCorretor, props.tipoLogLead],
    enabled: !!props.idLeadCorretor,
    refetchOnWindowFocus: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar histórico. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
